import { useCallback } from 'react';
import { CareType, OrganizationCareFlow, PaymentSource } from '../../graphQL';
import { RequireJust } from '../../types';
import { useCareTypeConfigContext } from '../CareTypeConfigContext';

export const useDisplayableType = () => {
  const { getCareTypeDisplay } = useCareTypeConfigContext();
  return useCallback(
    <T extends { careTypes: CareType[] }>(hasCareTypes: T) => {
      if (!hasCareTypes.careTypes.length) {
        return 'Provider';
      }
      return getCareTypeDisplay(hasCareTypes.careTypes[0]).providerTitle;
    },
    [getCareTypeDisplay]
  );
};

export type OrganizationWithCareFlows = {
  careFlows: RequireJust<OrganizationCareFlow, 'careType' | 'defaultPaymentSource'>[];
};

export const isSelfPayReferral = (
  provider: { organizations: OrganizationWithCareFlows[] },
  careType: CareType
) => {
  return Boolean(
    provider.organizations.length && hasSelfPayFlow(provider.organizations[0], [careType])
  );
};

export const hasSelfPayFlow = (org: OrganizationWithCareFlows, forCareTypes?: CareType[]) => {
  return org.careFlows.some(
    i =>
      i.defaultPaymentSource === PaymentSource.SelfPay &&
      (!forCareTypes || forCareTypes.includes(i.careType))
  );
};

export const hasAnySelfPayFlow = (org: {
  careFlows: RequireJust<OrganizationCareFlow, 'defaultPaymentSource' | 'careType'>[];
}) => hasSelfPayFlow(org);
